//集团化官网
//let domain = 'hk.group.com'//本地
let domain=document.domain;//线上

//var baseURL = 'http://dev.gsite.com' //本地
//let baseURL = '/apis' //本地
//let baseURL = 'http://b.eetopintest.com';//测试
//let baseURL = 'http://shopmo.eetop.com';//模测
let baseURL = window.location.protocol.indexOf('https') > -1 ? 'https://group-api.hzkqyyjt.com' : 'http://group-api.eetop.com';//线上

let url ='/groupfront';
//index接口相关
let indexUrl=`${url}/index`
let index={
    index:`${indexUrl}/index`,//集团配置信息
    banners:`${indexUrl}/banners`,//banner列表
    menus:`${indexUrl}/menus`,//栏目
    logos:`${indexUrl}/logos`//分院logo
}
let dynamicUrl=`${url}/dynamic`
let dynamic={
    classList:`${dynamicUrl}/class-list`,//动态分类
    list:`${dynamicUrl}/list`,//动态列表
    detail:`${dynamicUrl}/detail`,//动态详情
}
let recruitUrl=`${url}/recruit`;
let recruit={
    list:`${recruitUrl}/list`,//招贤纳士列表
    detail:`${recruitUrl}/detail`,//招贤纳士详情
    workplaces:`${recruitUrl}/workplaces`,//工作地点列表
    departments:`${recruitUrl}/departments`,//专业科室列表
}
let doctorGroupUrl=`${url}/doctor-group`;
let doctorGroup={
    list:`${doctorGroupUrl}/list`,//医生列表
    detail:`${doctorGroupUrl}/detail`,//医生详情
    reservation:`${doctorGroupUrl}/reservation`,//提交预约
    symptomList:`${doctorGroupUrl}/symptom-list`,//病症列表
}
let tcCollegeUrl=`${url}/tc-college`
let tcCollege={
    classList:`${tcCollegeUrl}/class-list`,//通策牙学院文章分类
    list:`${tcCollegeUrl}/list`,//通策牙学院文章列表
    detail:`${tcCollegeUrl}/detail`,//通策牙学院文章详情
}
let aboutUrl=`${url}/about`
let about={
    intro:`${aboutUrl}/intro`,//集团介绍及企业荣誉
    subHospitals:`${aboutUrl}/sub-hospitals`,//分院介绍
    contact:`${aboutUrl}/contact`//联系我们
}
export default{
    baseURL,
    domain,
    index,
    dynamic,
    recruit,
    doctorGroup,
    tcCollege,
    about
}


// WEBPACK FOOTER //
// ./src/utils/api.js